import { render, staticRenderFns } from "./GenerateCabinMonitoring.vue?vue&type=template&id=36bb63d0&scoped=true&"
import script from "./GenerateCabinMonitoring.vue?vue&type=script&lang=js&"
export * from "./GenerateCabinMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb63d0",
  null
  
)

export default component.exports